import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-07627884"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = {
  key: 0,
  class: "page-header"
}
const _hoisted_3 = {
  key: 0,
  class: "title"
}
const _hoisted_4 = {
  key: 1,
  class: "desc"
}
const _hoisted_5 = { class: "page-container" }
const _hoisted_6 = {
  key: 0,
  class: "loading-box"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_spin = _resolveComponent("a-spin")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ((!_ctx.windowTool && _ctx.title) || _ctx.desc)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_ctx.title)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.title), 1))
            : _createCommentVNode("", true),
          (_ctx.desc)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.desc), 1))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_5, [
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createVNode(_component_a_spin)
          ]))
        : _renderSlot(_ctx.$slots, "default", { key: 1 }, undefined, true)
    ])
  ]))
}